module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "login"
  }, [_c('section', {
    staticClass: "login__modal"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "login__title"
  }, [_vm._v(_vm._s(_vm.L.localize('Welcome')))]), _vm._v(" "), _c('form', {
    staticClass: "form js-form",
    attrs: {
      "data-form": "login"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    }
  }, [(_vm.error) ? _c('span', {
    staticClass: "form__validation"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_EmailAddress",
      "validate": _vm.$v,
      "autocomplete": "email",
      "placeholder": "Placeholder_Email",
      "modelPath": "email",
      "acc": "email"
    },
    on: {
      "input": _vm.$v.email.$touch
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Login_Password",
      "validate": _vm.$v,
      "autocomplete": "password",
      "placeholder": "Placeholder_Password",
      "modelPath": "password",
      "type": "password",
      "acc": "password"
    },
    on: {
      "input": _vm.$v.password.$touch
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "label": "Login_RememberMe"
    },
    model: {
      value: (_vm.remember),
      callback: function($$v) {
        _vm.remember = $$v
      },
      expression: "remember"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Login_LoginButton"
    },
    on: {
      "click": _vm.login
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "login__link link",
    attrs: {
      "to": {
        name: 'forgot-password'
      },
      "data-acc": "forgotPassword"
    }
  }, [_vm._v("\n        J'ai oublié mon mot de passe\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "login__header"
  }, [_c('img', {
    staticClass: "login__logo",
    attrs: {
      "alt": "userboat",
      "src": "/static/assets/logo/userboat-full.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-165ddeb4!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/account/Login.vue
// module id = 711
// module chunks = 1